import React, { useEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import Header from './header.tsx'
import reponsive, { SizeChangeCBArgs } from '@/utils/reponsive.ts'
import { useGlobalStore } from '@/hoxStore/globalStore.ts'
import classNames from 'classnames'
import { useLocation } from 'react-router-dom'
import { FloatButton } from 'antd'
import FootTwo from './footTwo/index.tsx'
interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = (props) => {
  const { setCurReponsive, curReponsive } = useGlobalStore()
  const location = useLocation()
  const [showMiniMenu, setShowMiniMenu] = useState(false)
  const layoutContainerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // 监听屏幕大小变化
    const cbOfSizeChange = (props: SizeChangeCBArgs) => {
      const _event = new CustomEvent(`event_sizeChange`)
      document.dispatchEvent(_event)
      setCurReponsive(props)
    }
    reponsive.init(cbOfSizeChange)
  }, [])

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1000px)')
    if (mediaQuery.matches) {
      setShowMiniMenu(true)
    } else {
      setShowMiniMenu(false)
    }
    mediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        setShowMiniMenu(true)
      } else {
        setShowMiniMenu(false)
      }
    })
  }, [])

  useEffect(() => {
    window?.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [location.pathname])

  return (
    <div className={classNames(styles.me_layout, `global_me_layout`)}>
      {/*头部*/}
      <Header isOldVersion={true} />
      {/*主体*/}
      <div
        className={classNames({
          [styles.layout_body]: true,
          [styles.layout_body_mini]: showMiniMenu,
          [styles.layout_body_old]: true,
        })}
      >
        <div className={styles.layout_main}>
          <div className={styles.layout_container} ref={layoutContainerRef}>
            {props.children}
            {layoutContainerRef.current && (
              <FloatButton.BackTop
                visibilityHeight={500}
                target={() => layoutContainerRef.current!}
              />
            )}
          </div>
        </div>
      </div>
      <FootTwo />
    </div>
  )
}

export default Layout
